export default {
  countCells: 5,
  massive: [
    {
      dataField: 'region',
      cols: 1,
      rows: 1,
      text: 'Регионы',
      class: 'd-flex align-center  ',
      headerClass: '  ',
      headerStyles: `min-width: 210px;`,
      order: 0,
      variable: true,
      template: (r) => r?.name ?? ''
    },
    {
      dataField: 'fio',
      cols: 1,
      rows: 1,
      text: `Ответственный`,
      class: `d-flex flex-row align-center   pl-2 `,
      headerClass: ' ',
      headerStyles: `min-width: 400px;`,
      order: 1,
      variable: true,
      template: r => r.contact.length ? `${r.contact[0]?.fio}<br><span class="font-size-extra-small">${r.contact[0]?.position}</span><br>
${r.contact[1]?.fio ?? ''}<br><span class="font-size-extra-small">${r.contact[1]?.position ?? ''}</span>` : ''
    },
    {
      dataField: 'numbers',
      cols: 1,
      rows: 1,
      text: `Телефоны`,
      class: `d-flex flex-column  justify-center  pl-2 `,
      headerClass: ' ',
      headerStyles: ``,
      order: 2,
      variable: true,
    },
    {
      dataField: 'email',
      cols: 1,
      rows: 1,
      order: 3,
      variable: true,
      class: `d-flex  flex-column  justify-center `,
      headerStyles: ``,
      headerClass: '',
      text: `Электронная почта`,
    },
    {
      dataField: 'filesDto',
      cols: 1,
      rows: 1,
      text: `Файлы`,
      class: `d-flex flex-column  justify-start  pl-2 `,
      headerClass: ' ',
      headerStyles: ``,
      order: 4,
      variable: true,
    },
  ]
}
